import React from "react";
import Logo from "../../../assets/image/Logo.png";
import style from "./Loading.module.scss";

export const Loading = () => {
  return (
    <div className={`fixed top-0 left-0 w-full h-full bg-nc-gray-bg z-50 flex items-center justify-center`}>
      {/* Contenedor del Logo */}
      <div className="flex flex-col items-center justify-center">
        <img
          src={Logo}
          className={`${style.animateFloat} w-24 h-24 animate-spin animate-bounce-slow`}
          alt="Loading Logo"
        />
        <h1 className="mt-4 font-sans text-4xl bg-gradient-to-r from-pc-purple to-pc-aqua-2 text-transparent bg-clip-text animate-pulse">
          LOADING
        </h1>
      </div>
    </div>
  );
};
